import styled from 'styled-components'

export const Badge = styled.span`
    border-radius: 50%;
    display: inline-block;
    height: 0.5rem;
    width: 0.5rem;
`